<template>
    <div class="container">
        <div class="top-nav-view">
            <div class="left-top-view" :style="{ cursor: currentRoute == '/companyList' ? '' : 'pointer' }"
                @click="clickLogo">
                <img class="logo-icon" :style="{ cursor: currentRoute == '/companyList' ? '' : 'pointer' }" :src="imgIcon"
                    alt="">
                <!-- <p class="logo-text margin-diot" :style="{cursor: currentRoute == '/companyList'? '':'pointer'} ">·</p> -->
                <!-- <p class="logo-text logo-text-title" :style="{cursor: currentRoute == '/companyList'? '':'pointer'} ">{{$t('yyxt')}}</p> -->
            </div>
            <div class="right-top-view" v-if="currentRoute != '/companyList'">
                <!-- <dropMenu :menuInfo="courseMenu" @dropCommand="courseDrop" /> -->
                <!-- <dropMenu :menuInfo="languageMenu" /> -->
                <dropMenu :menuInfo="userMenu" @dropCommand="userDrop" />
            </div>
        </div>
    </div>
</template>

<script>
import dropMenu from "@/components/home/dropMenu.vue";
import { logout } from "@/api/user";
import { getStore, setStore, clone, getSession, getImageLanguage } from "@/utils/index";
import { mapGetters } from "vuex";
import { getloacllanguage } from "@/utils/pageData"

export default {
    props: {
    },
    watch: {
        courseList(val) {

        },
        $route(val, old) {
            this.currentRoute = val.path;
        }
    },


    computed: {

        courseList: function () {
            const self = this;
            console.log(this.$store.state.user.courseList, '010101')
            if (!this.$store.state.user.courseList || (this.$store.state.user.courseList && this.$store.state.user.courseList.length == 0)) {
                self.$store.dispatch("setCourseList", JSON.parse(getSession("courseList")));
            }
            this.$forceUpdate();
            return this.$store.state.user.courseList


            // this.currentRoute  = this.$router.current.fullPath

        }
    },
    data() {
        return {
            imgIcon: require("../../assets/image/home/top_logo_icon.svg"),
            userMenu: {
                type: "user",
                dropArr: [
                    // {
                    //   name: this.$t("myAccount"),
                    //   action: "my"
                    // },
                    // {
                    //   name: this.$t("dataHandle"),
                    //   action: "data"
                    // },
                    // {
                    //   name: this.$t("logout"),
                    //   action: "logout"
                    // }
                ]
            },
            currentRoute: "",
            languageMenu: {
                type: "language",
                defaultValue: this.$t("language"),
                dropArr: [
                    {
                        name: '中文简体',
                        action: "chinese",
                        value: "zh_CN",
                    },
                    {
                        name: 'English',
                        action: "english",
                        value: "en_US",
                    },
                    {
                        name: '中文繁體',
                        action: "traditional",
                        value: "zh_TW",
                    },
                    {
                        name: 'ภาษาไทย',
                        action: "thai",
                        value: "th_TH",
                    }
                ]
            },
            // courseMenu: {
            //   type: "course",
            //   defaultValue: this.$t("allCourses"),
            //   dropArr: this.courseList
            // },
            userInfo: {}
        };
    },

    //  "zh_CN": "",//中文简体
    // "en_US": "EN",//英文
    // "zh_TW": "TW",//中文繁体
    // "th_TH": "TH",//泰文

    components: {
        dropMenu
    },
    created() {
        this.getImageIcon()
    },
    mounted() {
        this.getImageIcon()

        this.userInfo = JSON.parse(getStore("userInfo"));


        if (process.env.ENV_CONFIG == 'devOverseas' || process.env.ENV_CONFIG == 'prodOverseas' || process.env.ENV_CONFIG == 'thdev' || process.env.ENV_CONFIG == 'thuat' || process.env.ENV_CONFIG == 'thprod') {
            this.languageMenu = {
                type: "language",
                defaultValue: this.$t("language"),
                dropArr: [
                    {
                        name: '中文繁體',
                        action: "traditional",
                        value: "zh_TW"
                    },
                    {
                        name: 'ภาษาไทย',
                        action: "thai",
                        value: "th_TH"
                    },
                    {
                        name: 'English',
                        action: "english",
                        value: "en_US",
                    },
                ]
            }
        } else {
            this.languageMenu = {
                type: "language",
                defaultValue: this.$t("language"),
                dropArr: [
                    {
                        name: '中文简体',
                        action: "chinese",
                        value: "zh_CN",
                    }
                ]
            }
        }
        this.setLanguageMenu();
        this.getUserDropArr();
        this.currentRoute = this.$route.path
    },

    updated() {

        // debugger
        // this.courseMenu.dropArr = this.$store.state.user.courseList;
    },

    methods: {
        // setCourseMenu(val) {
        //   // let learningPathMetaId = getStore("learningPathMetaId")
        //   // console.log("learningPathMetaId===",learningPathMetaId)
        //   // for (let index = 0; index < val.length; index++) {
        //   //   let element = val[index];
        //   //   if (element.id == learningPathMetaId) {
        //   //     element.select = true
        //   //   } else {
        //   //     element.select = false
        //   //   }
        //   // }
        //   // getStore("learningPathMetaId", item.id)
        //   this.courseMenu.dropArr = []
        //   this.courseMenu.dropArr = val;
        // },
        getImageIcon() {
            let imageLanguage = getImageLanguage();
            //  "zh_CN": "cn",//中文简体
            //     "en_US": "en",//英文
            //     "zh_TW": "tw",//中文繁体
            //     "th_TH": "th",//泰文
            // console.log("audioViewRef", imageLanguage, this.$refs.audioViewRef)
            switch (imageLanguage) {
                case 'cn':
                    this.imgIcon = require('../../assets/image/home/top_logo_icon.svg');
                    break;
                case 'en':
                    this.imgIcon = require('../../assets/image/home/tip_info_img_th.jpg');
                    break;
                case 'tw':
                    this.imgIcon = require('../../assets/image/home/tip_info_img_tw.jpg');
                    break;
                case 'th':
                    this.imgIcon = require('../../assets/image/home/tip_info_img_th.jpg');
                    break;
                default:
                    break;
            }
        },
        setLanguageMenu() {
            let localeLanguage = window.localStorage.getItem("localeLanguage")
            for (let index = 0; index < this.languageMenu.dropArr.length; index++) {
                let element = this.languageMenu.dropArr[index];
                if (element.value == localeLanguage) {
                    element["select"] = true
                } else {
                    element["select"] = false
                }
            }
            let dropArrTemp = clone(this.languageMenu.dropArr)
            this.languageMenu.dropArr = []
            this.languageMenu.dropArr = dropArrTemp
            // console.log("this.languageMenu==", this.languageMenu)
            this.getImageIcon()
        },
        clickLogo() {
            if (this.currentRoute == '/companyList') {
                return
            }
            // console.log("this.$router==", this.$router.history.current.name)
            if (this.$router.history.current.name == 'home') {
                window.location.reload()
                return
            }

            this.$router.replace({ path: "/home" });
        },
        getHeaderCourseInfo(item) {
            setStore("learningPathMetaId", item.id)
            let courseList = this.$store.state.user.courseList;
            for (let index = 0; index < courseList.length; index++) {
                let element = courseList[index];
                if (element.id == item.id) {
                    element['select'] = true
                } else {
                    element['select'] = false
                }
            }
            setTimeout(() => {
                this.$store.dispatch("setCourseList", courseList);
            }, 300);
        },
        courseDrop(item) {
            console.log("item", item)
            // console.log("(this.$router===", this.$router)
            this.getHeaderCourseInfo(item)
            let queryData = { id: item.id }
            if (this.$router.history.current.name == 'overview') {
                this.$EventBus.$emit("refreshOverview", { queryData });
                window.scroll(0, 0)
                document.body.scrollTop = 0
                return
            }
            // setStore("learningPathMetaId", item.id)

            // let courseList = this.$store.state.user.courseList;
            // for (let index = 0; index < courseList.length; index++) {
            //   let element = courseList[index];
            //   if (element.id == item.id) {
            //     element['select'] = true
            //   } else {
            //     element['select'] = false
            //   }
            // }
            // console.log("setCourseList==", courseList)
            // this.$store.dispatch("setCourseList", []);
            // setTimeout(() => {
            //   this.$store.dispatch("setCourseList", courseList);
            // }, 300);
            // setStore("learningPathMetaId", item.id)
            window.scroll(0, 0)
            document.body.scrollTop = 0

            // 跳转到课程介绍页面
            // this.$router.push({
            //   path: "/overview",
            //   query: { id: item.id }
            // });

            // 直接跳转到课程里面
            console.log("item--", item)
            if (item.id == 0) {
                if (item.progress == 100) {
                    this.$router.push({
                        path: "/leadershipDNA/evaluationReport",
                        query: {},
                    });
                    return
                }
                this.$router.push({
                    path: "/leadershipDNA/evaluationIntroduction",
                    query: { id: this.id },
                });
            } else {
                console.log("currentcurrent", this.$router.history.current)

                if (this.$router.history.current.fullPath.indexOf("/course") != -1) {
                    console.log("yyyyyyy")

                    this.$EventBus.$emit("refreshCourse", { queryData });
                    window.scroll(0, 0)
                    document.body.scrollTop = 0
                    return
                }
                console.log("nnnnnnnn")

                this.$router.replace({ path: "/course", query: { id: item.id } });
            }


        },
        userDrop(item) {
            switch (item.action) {
                // 数据权益处理请求
                case "data":
                    this.$router.push({ path: "/datahandle" });
                    break;
                //切换至公司列表
                case "companyList":
                    this.$router.replace({ path: "/companyList" });
                    break;
                // 退出登录
                case "logout":
                    logout({}).then(res => {
                    });
                    setStore("userInfo", null);
                    this.$router.replace({
                        path: "/",
                        query: {
                            language: getloacllanguage()
                        }
                    });
                    break;
                default:
                    break;
            }
        },
        getUserDropArr() {
            if (this.userInfo) {
                if (this.userInfo.companyList && this.userInfo.companyList.length > 0) {
                    let arr = [
                        {
                            name: this.$t("switchCompany"),
                            action: "companyList"
                        },
                        {
                            name: this.$t("dataHandle"),
                            action: "data"
                        },
                        {
                            name: this.$t("logout"),
                            action: "logout"
                        }
                    ]
                    this.userMenu.dropArr = arr;
                } else {
                    let arr = [
                        {
                            name: this.$t("dataHandle"),
                            action: "data"
                        },
                        {
                            name: this.$t("logout"),
                            action: "logout"
                        }
                    ]
                    this.userMenu.dropArr = arr;
                }
            }
        },
    }
};
</script>

<style lang='scss' scoped>
.container {
    width: 100%;
    height: 0.375rem;
    background: #ffffff;
    box-shadow: 0px 0.0125rem 0.05rem 0px rgba(211, 211, 211, 0.5);
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}

.top-nav-view {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
    margin: 0px 1rem;
}

.left-top-view {
    display: flex;
    flex-direction: row;
    align-items: center;
    // cursor: pointer;
}

.logo-icon {
    width: 0.86875rem;
    height: 0.1375rem;
    // cursor: pointer;
}

.logo-text {
    color: #2e2e2e;
    font-size: 0.15rem;
    line-height: 0.20625rem;
    font-weight: bold;
    // cursor: pointer;
}

.logo-text-title {
    min-width: 0.9375rem;
}

.margin-diot {
    margin: 0px 0.10625rem;
}

.right-top-view {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 30%;
    min-width: 3rem;
}
</style>


// WEBPACK FOOTER //
// src/layout/components/Header.vue